/* PT · Cart behaviour (spec-cart-4a4b). Talks to /cart/*.js and updates the
   page in place — no section re-render, so nothing snaps: rows fade + collapse,
   numbers count to their new value, the upsell panel and stamp line ease in and
   out. Theme Editor: re-inits on section load. */
(function () {
  "use strict";
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var D = {};
  function cfg() { try { return JSON.parse((document.getElementById("pt-cart-data") || {}).textContent || "{}"); } catch (e) { return {}; } }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]; }); }
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  /* ---- money: Shopify's money_format ({{amount}}, {{amount_no_decimals}}, …) ---- */
  function money(cents) {
    var fmt = D.moneyFormat || "${{amount}}";
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt), key = m ? m[1] : "amount";
    var n = Math.round(Number(cents) || 0) / 100, out;
    function sep(num, thousands, decimal, places) {
      var s = num.toFixed(places), parts = s.split("."), int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return places ? int + decimal + parts[1] : int;
    }
    switch (key) {
      case "amount_no_decimals": out = sep(n, ",", ".", 0); break;
      case "amount_with_comma_separator": out = sep(n, ".", ",", 2); break;
      case "amount_no_decimals_with_comma_separator": out = sep(n, ".", ",", 0); break;
      case "amount_with_apostrophe_separator": out = sep(n, "'", ".", 2); break;
      case "amount_no_decimals_with_space_separator": out = sep(n, " ", ",", 0); break;
      case "amount_with_space_separator": out = sep(n, " ", ",", 2); break;
      case "amount_with_period_and_space_separator": out = sep(n, " ", ".", 2); break;
      default: out = sep(n, ",", ".", 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, "");
  }

  /* ---- numbers glide to their new value (240ms) instead of jumping ---- */
  function setCents(el, cents, pulse) {
    if (!el) return;
    var from = Number(el.getAttribute("data-cents") || 0), to = Math.round(Number(cents) || 0);
    el.setAttribute("data-cents", String(to));
    if (from === to) return;
    if (reduced || !window.requestAnimationFrame || document.hidden) { el.textContent = money(to); return; }
    var t0 = null, dur = 240;
    /* a background tab pauses rAF: make sure the final value always lands */
    setTimeout(function () { if (el.getAttribute("data-cents") === String(to)) el.textContent = money(to); }, dur + 80);
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur); p = 1 - Math.pow(1 - p, 3);
      el.textContent = money(from + (to - from) * p);
      if (p < 1) requestAnimationFrame(step); else el.textContent = money(to);
    }
    requestAnimationFrame(step);
    if (pulse) { el.classList.remove("pt-ct-pulse"); void el.offsetWidth; el.classList.add("pt-ct-pulse"); }
  }
  function swapText(el, text) {
    if (!el || el.textContent === String(text)) return;
    if (reduced) { el.textContent = text; return; }
    el.classList.add("pt-ct-swap");
    setTimeout(function () { el.textContent = text; el.classList.remove("pt-ct-swap"); }, 100);
  }

  /* ---- collapse / expand a grid-row wrapper (1fr → 0fr) ---- */
  function collapse(el, cb) {
    if (!el) { if (cb) cb(); return; }
    if (reduced) { el.hidden = true; if (cb) cb(); return; }
    el.classList.add("pt-ct-collapsed");
    var done = false;
    function fin() { if (done) return; done = true; el.hidden = true; if (cb) cb(); }
    /* only the height fold counts — the same element also transitions opacity
       and transform (the fade that runs first), and those end sooner */
    el.addEventListener("transitionend", function h(e) { if (e.target === el && e.propertyName === "grid-template-rows") { el.removeEventListener("transitionend", h); fin(); } });
    setTimeout(fin, 340);
  }
  function expand(el) {
    if (!el) return;
    el.hidden = false;
    if (reduced) { el.classList.remove("pt-ct-collapsed"); return; }
    el.classList.add("pt-ct-collapsed");
    void el.offsetHeight;
    setTimeout(function () { el.classList.remove("pt-ct-collapsed"); }, 20);
  }

  /* ---- cart JSON helpers ---- */
  function api(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || "error"); e.status = r.status; throw e; } return j; }); });
  }
  function getCart() { return fetch((D.routes && D.routes.cart || "/cart") + ".js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  function largestDiscountTitle(cart) {
    var best = null, amt = -1;
    (cart.cart_level_discount_applications || []).forEach(function (a) { var v = Number(a.total_allocated_amount || 0); if (v > amt) { amt = v; best = a.title; } });
    (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var v = Number(a.amount || 0); if (v > amt) { amt = v; best = a.discount_application && a.discount_application.title; } }); });
    return best ? String(best).split(":")[0].split("(")[0].trim() : "";
  }

  function init() {
    var root = document.getElementById("pt-cart");
    if (!root || root.__ptInit) return;
    root.__ptInit = true;
    D = cfg();
    var items = q("[data-ct-items]", root), sum = q("[data-ct-sum]", root), empty = q("[data-ct-empty]", root);
    var upsell = q("[data-ct-upsell]", root);
    var busy = false;   /* guards the one-shot actions (upsell add, codes) */

    /* ---- header count + count line ---- */
    function setCounts(cart) {
      var n = cart.item_count;
      qa("[data-header-cart-count]").forEach(function (el) { el.textContent = n; });
      var c = q("[data-ct-count]", root);
      if (c) { var txt = n === 1 ? (D.itemsOne || "1 item") : String(D.itemsMany || "{n} items").replace("{n}", n); if (c.textContent !== txt) { c.style.opacity = "0"; setTimeout(function () { c.textContent = txt; c.style.opacity = ""; }, 160); } }
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
    }

    /* ---- totals, stamp line, savings row ---- */
    function render(cart) {
      var original = Number(cart.original_total_price || 0), total = Number(cart.total_price || 0), savings = Math.max(0, original - total);
      setCents(q("[data-ct-subtotal]", root), original);
      setCents(q("[data-ct-total]", root), total, true);
      setCents(q("[data-ct-savings]", root), savings, true);
      var pct = original > 0 ? Math.round(savings * 100 / original) : 0;
      var stampName = savings > 0 ? (largestDiscountTitle(cart) || D.stampFallback || "Discount") : (D.stampFallback || "Discount");
      var stamp = q("[data-ct-stamp]", root), saveRow = q("[data-ct-saverow]", root);
      if (stamp) {
        var nm = q("[data-ct-stampname]", stamp), lead = q("[data-ct-stamppct]", stamp), rest = q("[data-ct-stampsave]", stamp);
        if (nm && nm.textContent !== stampName) nm.textContent = stampName;
        if (lead) lead.textContent = String(D.stampLead || "{pct}% off applied").replace("{pct}", pct);
        if (rest) rest.textContent = String(D.stampRest || "you save {amount}").replace("{amount}", money(savings));
        stamp.classList.toggle("pt-ct-hidden", savings <= 0);
      }
      if (saveRow) {
        var lbl = q("[data-ct-savelabel]", saveRow);
        if (lbl) lbl.textContent = String(D.savingsLabel || "{stamp} savings").replace("{stamp}", stampName);
        saveRow.classList.toggle("pt-ct-hidden", savings <= 0);
      }
      /* per-line totals */
      (cart.items || []).forEach(function (it, i) {
        var row = q('[data-ct-row][data-key="' + it.key + '"]', root); if (!row) return;
        row.setAttribute("data-line", String(i + 1));
        var fin = Number(it.final_line_price), orig = Number(it.original_line_price);
        var cmpUnit = Number(row.getAttribute("data-compare-unit") || 0), cmp = Math.max(orig, cmpUnit * it.quantity);
        setCents(q("[data-ct-linetotal]", row), fin);
        var cEl = q("[data-ct-linecompare]", row);
        if (cEl) { setCents(cEl, cmp); cEl.classList.toggle("pt-ct-hidden", cmp <= fin); }
        if (String(it.quantity) !== row.getAttribute("data-qty")) { row.setAttribute("data-qty", String(it.quantity)); var qEl = q("[data-ct-qty]", row); if (qEl) swapText(qEl, it.quantity); }
        var dec = q("[data-ct-dec]", row), inc = q("[data-ct-inc]", row);
        if (dec) dec.disabled = it.quantity <= 1; if (inc) inc.disabled = it.quantity >= 9;
        row.classList.remove("pt-ct-busy");
      });
      setCounts(cart);
      /* empty state */
      if (cart.item_count === 0) {
        root.classList.add("pt-cart--empty");
        if (sum && !sum.hidden) { if (reduced) sum.hidden = true; else { sum.classList.add("pt-ct-sheetout"); setTimeout(function () { sum.hidden = true; }, 320); } }
        if (empty) { empty.hidden = false; }
        if (upsell) collapse(upsell);
      }
      syncUpsell(cart);
      measureSheet();
      /* discount code chips */
      renderCodes(cart);
    }

    /* ---- upsell visibility: group member present, no remote ---- */
    function hasGroup(cart) { var ids = (D.groupIds || []).map(String); return (cart.items || []).some(function (it) { return ids.indexOf(String(it.product_id)) !== -1; }); }
    function hasRemote(cart) { return (cart.items || []).some(function (it) { return String(it.product_id) === String(D.remoteProductId); }); }
    function syncUpsell(cart) {
      if (!upsell || !D.remoteProductId) return;
      var want = hasGroup(cart) && !hasRemote(cart);
      if (want && upsell.hidden) expand(upsell);
      else if (!want && !upsell.hidden) collapse(upsell);
    }

    /* ---- row markup for a line added client-side (the remote) ---- */
    function rowHTML(it) {
      var short = it.product_title ? String(it.product_title).split(" – ")[0].split(" — ")[0].split(" - ")[0] : (D.remoteShort || it.title);
      (D.nameDrop || []).forEach(function (w) { w = String(w).trim(); if (w) short = short.split(w).join("").replace(/\s{2,}/g, " ").trim(); });
      var fin = Number(it.final_line_price), orig = Number(it.original_line_price), cmpUnit = String(it.product_id) === String(D.remoteProductId) ? Number(D.remoteCompare || 0) : 0;
      var cmp = Math.max(orig, cmpUnit * it.quantity);
      var img = it.featured_image && it.featured_image.url ? it.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : (it.image || "");
      var vari = (it.options_with_values || []).filter(function (o) { return o.value && o.value !== "Default Title"; }).map(function (o) { return /fit/i.test(o.value) ? '<span class="pt-ct-fit">' + esc(o.value) + "</span>" : '<span class="pt-ct-opt">' + esc(o.value) + "</span>"; }).join("");
      return '<div class="pt-ct-row pt-ct-collapsed" data-ct-row data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" data-product="' + it.product_id + '" data-compare-unit="' + cmpUnit + '"' + (String(it.product_id) === String(D.remoteProductId) ? " data-remote" : "") + ' hidden>' +
        '<div class="pt-ct-rowin"><a class="pt-ct-thumb" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") + '</a>' +
        '<div class="pt-ct-info"><a class="pt-ct-name" href="' + esc(it.url) + '">' + esc(short) + '</a>' + (vari ? '<span class="pt-ct-var">' + vari + '</span>' : "") + '</div>' +
        '<div class="pt-ct-acts"><span class="pt-ct-step" data-ct-step><button type="button" class="pt-ct-dec" data-ct-dec aria-label="' + esc(D.a11yDec) + '"' + (it.quantity <= 1 ? " disabled" : "") + '>&minus;</button><span class="pt-ct-qty" data-ct-qty aria-live="polite">' + it.quantity + '</span><button type="button" class="pt-ct-inc" data-ct-inc aria-label="' + esc(D.a11yInc) + '"' + (it.quantity >= 9 ? " disabled" : "") + '>+</button></span><button type="button" class="pt-ct-remove" data-ct-remove>' + esc(D.removeLabel || "Remove") + '</button></div>' +
        '<div class="pt-ct-price"><span class="pt-ct-total" data-ct-linetotal data-cents="' + fin + '">' + money(fin) + '</span><s class="pt-ct-compare' + (cmp <= fin ? " pt-ct-hidden" : "") + '" data-ct-linecompare data-cents="' + cmp + '">' + money(cmp) + '</s></div></div></div>';
    }
    function insertRows(cart) {
      (cart.items || []).forEach(function (it, i) {
        if (q('[data-ct-row][data-key="' + it.key + '"]', root)) return;
        var tmp = document.createElement("div"); tmp.innerHTML = rowHTML(it);
        var row = tmp.firstChild;
        var next = cart.items[i + 1] ? q('[data-ct-row][data-key="' + cart.items[i + 1].key + '"]', root) : null;
        items.insertBefore(row, next);
        expand(row);
      });
    }

    /* ---- quantity + remove ----
       The count changes at once (100ms swap); the request follows after a short
       debounce so quick taps collapse into one call. Removal leaves first
       (fade + slide, then the height folds), the request runs alongside. */
    function change(row, qty) {
      if (row.__removing) return;
      var key = row.getAttribute("data-key");
      if (qty === 0) {
        row.__removing = true; clearTimeout(row.__t);
        row.classList.add("pt-ct-out");
        setTimeout(function () { collapse(row, function () { row.parentNode && row.parentNode.removeChild(row); }); }, reduced ? 0 : 180);
        api(D.routes.change, { id: key, quantity: 0 }).then(render).catch(function (e) { toastErr(e); getCart().then(function (c) { insertRows(c); render(c); }); });
        return;
      }
      row.setAttribute("data-qty", String(qty));
      var qEl = q("[data-ct-qty]", row); if (qEl) swapText(qEl, qty);
      var dec = q("[data-ct-dec]", row), inc = q("[data-ct-inc]", row);
      if (dec) dec.disabled = qty <= 1; if (inc) inc.disabled = qty >= 9;
      row.classList.add("pt-ct-busy");
      clearTimeout(row.__t);
      row.__t = setTimeout(function () {
        api(D.routes.change, { id: key, quantity: Number(row.getAttribute("data-qty")) }).then(function (cart) {
          /* a newer tap may have moved on; only paint if this is the latest */
          var mine = (cart.items || []).filter(function (it) { return it.key === key; })[0];
          if (mine && String(mine.quantity) !== row.getAttribute("data-qty") && row.__t) return;
          render(cart);
        }).catch(function (e) { toastErr(e); getCart().then(render); });
      }, 220);
    }
    root.addEventListener("click", function (e) {
      var t = e.target.closest ? e.target : null; if (!t) return;
      var row = t.closest("[data-ct-row]");
      if (t.closest("[data-ct-dec]") && row) { var n = Number(row.getAttribute("data-qty")) - 1; if (n >= 1) change(row, n); return; }
      if (t.closest("[data-ct-inc]") && row) { var m = Number(row.getAttribute("data-qty")) + 1; if (m <= 9) change(row, m); return; }
      if (t.closest("[data-ct-remove]") && row) { change(row, 0); return; }
      if (t.closest("[data-ct-upadd]")) { addRemote(t.closest("[data-ct-upadd]")); return; }
      if (t.closest("[data-ct-codetoggle]")) { toggleCode(); return; }
      if (t.closest("[data-ct-apply]")) { applyCode(); return; }
      if (t.closest("[data-ct-coderm]")) { removeCode(t.closest(".pt-ct-codechip")); return; }
    });
    /* links that leave the page hold the pressed state until the next page arrives */
    root.addEventListener("click", function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest("a[href]"); if (!a) return;
      var href = a.getAttribute("href") || ""; if (!href || href.charAt(0) === "#" || a.target === "_blank") return;
      a.classList.add("pt-pressed"); setTimeout(function () { a.classList.remove("pt-pressed"); }, 4000);
    });
    window.addEventListener("pageshow", function (e) { if (e.persisted) qa(".pt-pressed, .pt-ct-busy", root).forEach(function (el) { el.classList.remove("pt-pressed"); el.classList.remove("pt-ct-busy"); }); });

    /* ---- upsell add ---- */
    function addRemote(btn) {
      if (busy || !D.remoteVariantId) return; busy = true;
      btn.classList.add("pt-ct-busy");
      api(D.routes.add, { items: [{ id: D.remoteVariantId, quantity: 1 }] }).then(function () { return getCart(); }).then(function (cart) {
        btn.classList.remove("pt-ct-busy"); btn.classList.add("pt-ct-ok");
        insertRows(cart);
        setTimeout(function () { render(cart); }, 60);
        setTimeout(function () { btn.classList.remove("pt-ct-ok"); }, 800);
      }).catch(function (e) { btn.classList.remove("pt-ct-busy"); toastErr(e); }).finally(function () { busy = false; });
    }

    /* ---- discount codes ---- */
    var codeWrap = q("[data-ct-codewrap]", root), codeToggle = q("[data-ct-codetoggle]", root), codeIn = q("[data-ct-codein]", root), codeErr = q("[data-ct-codeerr]", root), codes = q("[data-ct-codes]", root);
    function toggleCode() {
      if (!codeWrap) return;
      var open = !codeWrap.classList.contains("pt-ct-open");
      codeWrap.classList.toggle("pt-ct-open", open);
      if (codeToggle) codeToggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (open && codeIn) setTimeout(function () { codeIn.focus(); }, 250);
      setTimeout(measureSheet, 300);
    }
    function showErr(msg) { if (!codeErr) return; codeErr.textContent = msg; codeErr.classList.add("pt-ct-on"); setTimeout(measureSheet, 260); }
    function hideErr() { if (codeErr) codeErr.classList.remove("pt-ct-on"); }
    function currentCodes() { return qa(".pt-ct-codechip", root).map(function (c) { return c.getAttribute("data-code"); }); }
    function applyCode() {
      if (!codeIn || busy) return;
      var v = codeIn.value.trim(); if (!v) { codeIn.focus(); return; }
      busy = true; hideErr();
      var btn = q("[data-ct-apply]", root); if (btn) btn.classList.add("pt-ct-busy");
      var all = currentCodes().concat([v]);
      api(D.routes.update, { discount: all.join(",") }).then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (c) { return String(c.code).toLowerCase() === v.toLowerCase(); })[0];
        if (!hit || !hit.applicable) { showErr(D.codeError || "That code didn't work."); if (hit && !hit.applicable) return api(D.routes.update, { discount: currentCodes().join(",") }); return; }
        codeIn.value = "";
        render(cart);
      }).catch(function (e) { showErr(D.genericError || e.message); }).finally(function () { if (btn) btn.classList.remove("pt-ct-busy"); busy = false; });
    }
    if (codeIn) codeIn.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); applyCode(); } });
    function removeCode(chip) {
      if (!chip || busy) return; busy = true;
      var code = chip.getAttribute("data-code");
      chip.classList.add("pt-ct-out");
      api(D.routes.update, { discount: currentCodes().filter(function (c) { return c !== code; }).join(",") || "" }).then(function (cart) { render(cart); }).catch(function (e) { chip.classList.remove("pt-ct-out"); toastErr(e); }).finally(function () { busy = false; });
    }
    function renderCodes(cart) {
      if (!codes) return;
      var live = (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
      qa(".pt-ct-codechip", codes).forEach(function (chip) { if (live.indexOf(chip.getAttribute("data-code")) === -1) { chip.classList.add("pt-ct-out"); setTimeout(function () { chip.parentNode && chip.parentNode.removeChild(chip); }, 200); } });
      live.forEach(function (c) {
        if (q('.pt-ct-codechip[data-code="' + c.replace(/"/g, '\\"') + '"]', codes)) return;
        var s = document.createElement("span"); s.className = "pt-ct-codechip"; s.setAttribute("data-code", c);
        s.innerHTML = esc(c) + '<button type="button" data-ct-coderm aria-label="' + esc(D.removeLabel || "Remove") + '">&times;</button>';
        codes.appendChild(s);
      });
      setTimeout(measureSheet, 60);
    }

    /* ---- checkout: held press + ring while the checkout page loads ---- */
    var form = q("#pt-cart-form", root), checkout = q("[data-ct-checkout]", root), terms = q("[data-ct-terms]", root);
    if (terms && checkout) terms.addEventListener("change", function () { checkout.disabled = !terms.checked; });
    if (form && checkout) form.addEventListener("submit", function () { checkout.classList.add("pt-ct-busy"); });

    /* ---- mobile sheet: reserve its height under the list ---- */
    function measureSheet() {
      if (!sum || sum.hidden) return;
      var h = window.matchMedia("(min-width: 900px)").matches ? null : sum.offsetHeight + "px";
      /* on <html> so the chat launcher (outside the section) can sit above the sheet too */
      if (h) { root.style.setProperty("--pt-ct-sheet", h); document.documentElement.style.setProperty("--pt-ct-sheet", h); }
      else { root.style.removeProperty("--pt-ct-sheet"); document.documentElement.style.removeProperty("--pt-ct-sheet"); }
    }
    if (window.ResizeObserver && sum) new ResizeObserver(measureSheet).observe(sum);
    window.addEventListener("resize", measureSheet);
    measureSheet();

    /* ---- errors: a quiet line under the code field or a console note ---- */
    function toastErr(e) { var msg = (e && e.message) || D.genericError || "Something went wrong."; if (codeErr) { showErr(msg); setTimeout(hideErr, 3500); } }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", function (e) { if (e.target && e.target.querySelector && e.target.querySelector("#pt-cart")) { var r = e.target.querySelector("#pt-cart"); r.__ptInit = false; init(); } });
})();
